import { Phone, Navigation } from "lucide-react";
import { BUSINESS } from "@/data/content";

export default function MobileCallBar() {
  return (
    <div
      className="lg:hidden fixed bottom-0 left-0 right-0 z-40 bg-[#FDFBF7]/95 backdrop-blur-xl border-t border-[#E8E3D9] px-3 py-3 pb-[calc(0.75rem+env(safe-area-inset-bottom))] grid grid-cols-2 gap-3"
      data-testid="mobile-call-bar"
    >
      <a
        href={BUSINESS.phoneHref}
        className="inline-flex items-center justify-center gap-2 rounded-full bg-[#2A1B14] text-[#FDFBF7] px-4 py-3.5 font-body font-semibold text-sm active:scale-[0.98] transition-transform"
        data-testid="mobilebar-call"
      >
        <Phone size={17} /> Chiama
      </a>
      <a
        href={BUSINESS.mapsDir}
        target="_blank"
        rel="noreferrer"
        className="inline-flex items-center justify-center gap-2 rounded-full border border-[#2A1B14]/25 text-[#2A1B14] px-4 py-3.5 font-body font-semibold text-sm active:scale-[0.98] transition-transform"
        data-testid="mobilebar-directions"
      >
        <Navigation size={17} /> Indicazioni
      </a>
    </div>
  );
}
